define([
	"dojo/_base/declare",
	"csi/heading/StringContainer"
], function(declare,StringContainer) {

	return declare(StringContainer, {
		separator: ','
	});
});